module.exports = __webpack_public_path__ + "static/media/ericssonLogo.0cdf9d8f.png";